import { useQuery } from '@apollo/client';
import { GET_ACTIVITY } from 'graphql/secure/queries/activity.queries';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { IActivity } from 'FeatureModules/Activity/types/activity.types';

const ActivityTitle: FC = () => {
  const { id } = useParams<{
    id: string;
  }>();

  const { data, loading } = useQuery<{
    activity: IActivity;
  }>(GET_ACTIVITY, { variables: { id } });

  if (loading) {
    return <span> Loading..</span>;
  }

  return <span>{data?.activity.title || 'Loading..'}</span>;
};

export default ActivityTitle;
